import { Skeleton } from "@/shared/ui";

export default function VolunteerProfileSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="p-7 radius-3xl surface-base-fill flex items-center gap-4">
        <Skeleton circle width={64} height={64} />
        <Skeleton height={24} width={220} borderRadius={4} />
      </div>

      <div className="p-7 radius-3xl surface-base-fill">
        <Skeleton height={20} width={160} className="mb-7" borderRadius={4} />
        <div className="flex flex-col">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex justify-between items-center py-4 first:pt-0 last:pb-0 not-last:border-b surface-component-stroke">
              <div className="flex items-center gap-2">
                <Skeleton width={18} height={18} borderRadius={4} className="shrink-0" />
                <Skeleton height={14} width={100} borderRadius={4} />
              </div>
              <Skeleton height={14} width={160} borderRadius={4} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
